<h1 class="page-title mb-5"> مسابقة التميز في مجال التنمية المستدامة لعام 2023 </h1>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <p class="text-danger">تنوية هام </p>
                <p>بنهاية يوم الخميس 29 فبراير 2024 تم إنتهاء فترة التقديم لمسابقة التميز في مجال التنمية المستدامة لعام
                    2023
                </p>
                <p>مع خالص التوفيق والتقدير
                </p>
                <p>قائمة الشركات الفائزة في المسابقة لسنة 2020/2021</p>
                <div class="row g-4 mt-4">
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo1.png" class="img-fluid" alt="Company Logo 1"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo2.png" class="img-fluid" alt="Company Logo 2"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo3.png" class="img-fluid" alt="Company Logo 3"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo4.png" class="img-fluid" alt="Company Logo 4"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo5.png" class="img-fluid" alt="Company Logo 5"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo6.png" class="img-fluid" alt="Company Logo 6"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo7.png" class="img-fluid" alt="Company Logo 7"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo8.png" class="img-fluid" alt="Company Logo 8"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo9.png" class="img-fluid" alt="Company Logo 9"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo10.png" class="img-fluid" alt="Company Logo 10"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo11.png" class="img-fluid" alt="Company Logo 11"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo12.png" class="img-fluid" alt="Company Logo 12"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo13.png" class="img-fluid" alt="Company Logo 13"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo14.png" class="img-fluid" alt="Company Logo 14"
                                style="max-height: 80px;">
                        </a>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <a href="#"
                            class="d-block p-3 border rounded h-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <img src="../../assets/companylogo15.png" class="img-fluid" alt="Company Logo 15"
                                style="max-height: 80px;">
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <app-fix-how-we-can-help></app-fix-how-we-can-help>
            </div>
        </div>
    </div>
</div>